<template>
  <div class="empty">
    <div class="empty__text">
      <div class="empty__number">Nenhum dado encontrado</div>
      <div class="empty__msg">Seja o primeiro a adicionar um dado.</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped lang="scss">
.empty {
  display: flex;
  justify-content: center;
  margin: 20px 0 40px;
  align-items: center;
  flex-direction: column;
  text-align: center;
  &__text {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  &__number {
    display: block;
    text-align: center;
    font-size: 24px;
  }
}
</style>
